import React from 'react';
import Appearance from 'styles/Appearance.js';
import Utils from 'files/Utils.js';

// Limited-time offer badge. Renders nothing when `percent` is 0.
//   default  — "15% off · Limited time" tinted pill, beside a price (product page)
//   compact  — solid "15% off" label, laid over a product card's image corner,
//              where the countdown banner already says it's limited time
const OfferTag = ({ percent, compact = false, style }) => {
    if(!(percent > 0)) {
        return null;
    }
    // Whole-number label only; prices still use the exact percent (often
    // precise, e.g. 44.94382022, to land on a round price).
    const label = `${Math.max(1, Math.round(percent))}% off`;
    return (
        <span style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: 6,
            backgroundColor: compact ? Appearance.colors.success : Utils.hexToRGBA(Appearance.colors.success, 0.12),
            color: compact ? Appearance.colors.white : Appearance.colors.success,
            padding: compact ? '6px 11px' : '4px 10px',
            borderRadius: 999,
            fontFamily: Appearance.fonts.body,
            fontSize: compact ? 12.5 : 11.5,
            fontWeight: 700,
            whiteSpace: 'nowrap',
            boxShadow: compact ? '0 2px 8px rgba(0,0,0,0.12)' : 'none',
            ...style,
        }}>
            <i className={'fas fa-bolt'} style={{ fontSize: compact ? 11 : 10 }} />
            {compact ? label : `${label} · Limited time`}
        </span>
    );
};

export default OfferTag;
